import type { MugshotConfig } from '@/shared/lib/mugshot';
import { MugshotPortrait } from '../mugshot/MugshotPortrait';

export type PortraitInnerProps = {
  mugshot: MugshotConfig;
  index: number;
};

/** Polaroid-portrait body — scaled mugshot + N° badge in the corner. */
export const PortraitInner = ({ mugshot, index }: PortraitInnerProps) => (
  <>
    <MugshotPortrait config={mugshot} className="scale-150" />
    <span className="absolute right-1 bottom-0.5 font-mono text-[7px] text-ink/45 uppercase tracking-[0.14em]">
      N°{String(index + 1).padStart(2, '0')}
    </span>
  </>
);
